import alt from '../alt';

class filterAction {
    constructor() {
        this.generateActions(
            'processing',
            'employeeSuccess',
            'condoSuccess',
            'updateSuccess',
            'addSuccess',
            'removeSuccess',
            'removeCondo',
            'addCondo',
            'contractorSuccess',
            'removeContractorSuccess',
            'addContractorSuccess',
            'updateCondo',
            'updateContractor',
            'teamMember',
            'teamCondo',
            'holiday',
        );
    }

    getHoliday(){
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/holiday', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.holiday(result);
                    }else{
                        //handle error
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
       
        return true;
    }
    getTeamCondo(){
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/team/condo', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.teamCondo(result);
                    }else{
                        //handle error
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
       
        return true;
    }
    getTeamMember(){
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/team/member', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.teamMember(result);
                    }else{
                        //handle error
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
       
        return true;
    }
    getContractors() {
        
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/contractors', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.contractorSuccess(result);
                    }else{
                        //handle error
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
       
        return true;
    }
    getEmployee() {

        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/employee', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.employeeSuccess(result);
                    } else {
                        //handle error
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        this.processing(false);
        return true;
    }

    getCondoList() {

        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/condo', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.condoSuccess(result);
                    } else {
                        //handle error
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        
        return true;
    }


}
export default alt.createActions(filterAction);


// WEBPACK FOOTER //
// ./app/actions/filterAction.js